import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer
            className="relative text-white pt-16 pb-8 bg-cover bg-center mt-auto bg-[#040D1A]"
            style={{ backgroundImage: "url('/footer-bg.jpg')" }}
        >
            {/* Dark Blue Overlay */}
            <div className="absolute inset-0 bg-[#040D1A]/95"></div>

            <div className="container mx-auto px-6 relative z-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 pb-12 border-b border-blue-900/50">

                {/* Column 1: Logo & Contact details */}
                <div className="flex flex-col items-start lg:col-span-1">
                    <img
                        src="/logo.png"
                        alt="LEV India Logo"
                        className="h-16 mb-4 bg-white p-2 rounded object-contain"
                        onError={(e) => { e.target.style.display = 'none' }}
                    />
                    <p className="text-blue-400 font-semibold text-sm mb-4">
                        Connecting Strength. Delivering Reliability.
                    </p>

                    <div className="space-y-3 text-xs text-gray-300">
                        <p className="flex items-center gap-2">
                            <span className="text-blue-400">📞</span>
                            <a href="tel:+917982747220" className="hover:text-white">+91-7982747220</a>
                        </p>
                        <p className="flex items-center gap-2">
                            <span className="text-blue-400">📧</span>
                            <a href="mailto:likaievindia@gmail.com" className="hover:text-white">likaievindia@gmail.com</a>
                        </p>
                        <p className="flex items-start gap-2">
                            <span className="text-blue-400 mt-0.5">📍</span>
                            <span>WORKS: Plot No. 16, Bhoorgarhi Road, Dasna, Ghaziabad, UP - 201015</span>
                        </p>
                    </div>
                </div>

                {/* Column 2: Explore / Menu Links */}
                <div>
                    <h4 className="font-bold text-sm tracking-wider uppercase mb-4 border-l-2 border-blue-500 pl-2 text-white">Explore</h4>
                    <ul className="space-y-2 text-xs text-gray-300">
                        {[
                            { name: 'Home', path: '/' },
                            { name: 'About Us', path: '/about' },
                            { name: 'Our Products', path: '/products' },
                            { name: 'Gallery', path: '/gallery' },
                            { name: 'Enquiry', path: '/enquiry' },
                            { name: 'Contact Us', path: '/contact' }
                        ].map(item => (
                            <li key={item.name} className="hover:text-white transition duration-300">
                                <Link to={item.path} className="flex items-center justify-between group">
                                    <span className="group-hover:translate-x-1 transition-transform">{item.name}</span>
                                    <span className="text-blue-400">›</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Column 3: Our Products (Clickable to specific products) */}
                <div>
                    <h4 className="font-bold text-sm tracking-wider uppercase mb-4 border-l-2 border-blue-500 pl-2 text-white">Our Products</h4>
                    <ul className="space-y-2 text-xs text-gray-300">
                        {[
                            { name: 'ADSS Cable Accessories', path: '/products' },
                            { name: 'Type-1 Helical Fittings', path: '/products' },
                            { name: 'Type-3 Thermoplastic Fittings', path: '/products' },
                            { name: 'Hardware & Brackets', path: '/products' },
                            { name: 'View All Products', path: '/products' }
                        ].map(item => (
                            <li key={item.name} className="hover:text-white transition duration-300">
                                <Link to={item.path} className="flex items-center justify-between group">
                                    <span className="group-hover:translate-x-1 transition-transform">{item.name}</span>
                                    <span className="text-blue-400">›</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Column 4: Industries */}
                <div>
                    <h4 className="font-bold text-sm tracking-wider uppercase mb-4 border-l-2 border-blue-500 pl-2 text-white">Industries</h4>
                    <ul className="space-y-2 text-xs text-gray-300">
                        {[
                            'Power Transmission & Distribution',
                            'Telecom Infrastructure',
                            'Railway Infrastructure',
                            'Urban Infrastructure',
                            'Rural Electrification & Utilities'
                        ].map(name => (
                            <li key={name} className="hover:text-white transition duration-300">
                                <Link to="/about" className="flex items-center justify-between group">
                                    <span className="group-hover:translate-x-1 transition-transform">{name}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Column 5: Get In Touch */}
                <div>
                    <h4 className="font-bold text-sm tracking-wider uppercase mb-4 border-l-2 border-blue-500 pl-2 text-white">Get In Touch</h4>
                    <p className="text-xs text-gray-300 mb-4 leading-relaxed">
                        Have a query or need a custom solution? We're here to help.
                    </p>
                    <Link to="/contact">
                        <button className="w-full border border-blue-500 hover:bg-blue-600 text-white font-semibold py-2.5 px-4 rounded text-xs transition duration-300 flex items-center justify-center gap-2 group">
                            CONTACT US
                            <span className="group-hover:translate-x-1 transition-transform">→</span>
                        </button>
                    </Link>
                </div>
            </div>

            {/* Middle Feature Bar */}
            <div className="container mx-auto px-6 relative z-20 py-8 border-b border-blue-900/50">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="flex items-center gap-4 bg-blue-950/40 p-4 rounded border border-blue-900/30">
                        <span className="text-2xl text-blue-400">🛡️</span>
                        <div>
                            <h5 className="font-bold text-xs text-white uppercase">Quality Assured</h5>
                            <p className="text-[11px] text-gray-400">Manufactured to international standards</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-4 bg-blue-950/40 p-4 rounded border border-blue-900/30">
                        <span className="text-2xl text-blue-400">⚙️</span>
                        <div>
                            <h5 className="font-bold text-xs text-white uppercase">Advanced Manufacturing</h5>
                            <p className="text-[11px] text-gray-400">State-of-the-art infrastructure</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-4 bg-blue-950/40 p-4 rounded border border-blue-900/30">
                        <span className="text-2xl text-blue-400">🌐</span>
                        <div>
                            <h5 className="font-bold text-xs text-white uppercase">Global Reach</h5>
                            <p className="text-[11px] text-gray-400">Serving countries across the world</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-4 bg-blue-950/40 p-4 rounded border border-blue-900/30">
                        <span className="text-2xl text-blue-400">🎧</span>
                        <div>
                            <h5 className="font-bold text-xs text-white uppercase">Customer Support</h5>
                            <p className="text-[11px] text-gray-400">Dedicated support for all requirements</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Copyright & Social Links */}
            <div className="container mx-auto px-6 relative z-20 pt-6 flex flex-col md:flex-row items-center justify-between text-xs text-gray-400 gap-4">
                <p>Copyright © {new Date().getFullYear()} LIKAI EV INDIA. All Rights Reserved.Design & Development Live India Tech </p>

                <div className="flex flex-wrap gap-6 text-gray-400">
                    <Link to="/contact" className="hover:text-white transition">Privacy Policy</Link>
                    <span>|</span>
                    <Link to="/contact" className="hover:text-white transition">Terms & Conditions</Link>
                    <span>|</span>
                    <Link to="/contact" className="hover:text-white transition">Return & Refund Policy</Link>
                    <span>|</span>
                    <Link to="/contact" className="hover:text-white transition">Sitemap</Link>
                </div>

                <div className="flex items-center gap-3">
                    <span className="font-semibold text-white mr-2">FOLLOW US</span>
                    <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="w-8 h-8 rounded-full bg-blue-900/60 border border-blue-700 flex items-center justify-center hover:bg-blue-600 text-white transition">in</a>
                    <a href="https://facebook.com" target="_blank" rel="noreferrer" className="w-8 h-8 rounded-full bg-blue-900/60 border border-blue-700 flex items-center justify-center hover:bg-blue-600 text-white transition">f</a>
                    <a href="https://instagram.com" target="_blank" rel="noreferrer" className="w-8 h-8 rounded-full bg-blue-900/60 border border-blue-700 flex items-center justify-center hover:bg-blue-600 text-white transition">📷</a>
                    <a href="https://youtube.com" target="_blank" rel="noreferrer" className="w-8 h-8 rounded-full bg-blue-900/60 border border-blue-700 flex items-center justify-center hover:bg-blue-600 text-white transition">▶</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;